import React from 'react';
import Button, { ButtonGroup, LoadingButton, type ButtonProps } from '@atlaskit/button';
import { FormFooter } from '@atlaskit/form';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export type FooterProps = {
	isLoading: boolean;
	hasFormChanged: boolean;
	onSubmit: ButtonProps['onClick'];
	onCancel: ButtonProps['onClick'];
};

export const Footer = ({ hasFormChanged, isLoading, onSubmit, onCancel }: FooterProps) => {
	const { formatMessage } = useIntl();

	return (
		<FormFooter align="start">
			<ButtonGroup>
				<LoadingButton
					testId="servicedesk-customer-permissions.ui.form.footer.submit-button"
					isLoading={isLoading}
					appearance="primary"
					isDisabled={!hasFormChanged}
					onClick={onSubmit}
				>
					{formatMessage(messages.savePermissions)}
				</LoadingButton>
				{hasFormChanged && !isLoading && (
					<Button
						testId="servicedesk-customer-permissions.ui.form.footer.cancel-button"
						appearance="link"
						onClick={onCancel}
					>
						{formatMessage(messages.cancelPermissions)}
					</Button>
				)}
			</ButtonGroup>
		</FormFooter>
	);
};
